import { Tabs } from "antd";
import Register from "./Register";
import LabelboxGallery from "./LabelboxGallery";
import CollectionExplorer from "./CollectionExplorer";
import AdminUserManager from "./AdminUserManager";
import JsonImportPage from "./JsonImportPage";
const AdminPanel = () => {
  const items = [
    {
      key: "1",
      label: "👤 ユーザー登録",
      children: <Register />,
    },
    {
      key: "2",
      label: "🖼️ ギャラリー",
      children: <LabelboxGallery />,
    },
    {
      key: "3",
      label: "📂 コレクション参照",
      children: <CollectionExplorer />,
    },
    {
      key: "4",
      label: "🧑‍🌾 ユーザー情報",
      children: <AdminUserManager />,
    },
    {
      key: "5",
      label: "📥 JSONインポート",
      children: <JsonImportPage />,
    },

  ];

  return (
    <div style={{ padding: 20 }}>
      <Tabs defaultActiveKey="1" items={items} type="card" />
    </div>
  );
};

export default AdminPanel;

